import React, { cloneElement } from 'react';
import {
    List, Filter, Datagrid, TextInput, TextField, useListContext, TopToolbar, ExportButton, sanitizeListRestProps,
    DeleteButton, CreateButton, usePermissions, useRefresh, SelectInput, EmailField
} from 'react-admin';
import ISConfig from '../config';

const ActionButtons = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        record,
    } = useListContext();

    return (
        <TopToolbar className="mb-3" {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {!ISConfig.qbi ? <CreateButton basePath={basePath} record={record} /> : null}
            <ExportButton />
        </TopToolbar>
    );
}

const CustomerFilter = (props) => {
    var CustomerStatusSelectChoices = [];
    if (ISConfig.statuses != undefined || ISConfig.statuses != null) { ISConfig.statuses.customer.forEach(element => { CustomerStatusSelectChoices.push({ id: element, name: element }) }); }
    return (
        <Filter {...props}>
            <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Name</h6>} source="name" fullWidth variant="outlined" alwaysOn />
            <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Client Code</h6>} source="client_code" fullWidth variant="outlined" />
            <SelectInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Status</h6>} source="status" choices={CustomerStatusSelectChoices} fullWidth variant="outlined" />
            <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>Email</h6>} source="email" fullWidth variant="outlined" />
            {ISConfig.qbi ? <TextInput className="pt-1" label={<h6 className="px-2 small rounded" style={{ backgroundColor: 'rgb(250, 250, 250)' }}>QB ID</h6>} source="qbid" fullWidth variant="outlined" /> : null}
        </Filter>
    )
};

const CustomerList = props => {
    const toRedirect = useRefresh();
    const p = usePermissions();
    const isAdmin = p.loaded && p.permissions && 'user' in p.permissions && 'admin' in p.permissions && p.permissions.admin;
    const CustomerDeleteButton = isAdmin ? (<DeleteButton redirect={toRedirect} />) : '';

    return (
        <>
            <h3 className="text-danger px-3 px-md-0 pt-3 pt-md-0" style={{ fontFamily: 'Arial, sans-serif' }}>Customers</h3>
            <List {...props} filters={<CustomerFilter />} filter={{ has_location: true }} actions={<ActionButtons />} bulkActionButtons={false} title=" ">
                <Datagrid rowClick="show" className="table table-sm table-hover table-borderless">
                    <TextField source="name" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Name </h6>} />
                    <TextField source="status" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Status </h6>} />
                    <EmailField source="email" className="px-3 text-lowercase" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Email </h6>} />
                    <TextField source="client_code" className="px-3 text-capitalize" label={<h6 className="text-secondary px-3" style={{ marginBottom: '2px', fontSize: '14px', fontFamily: 'Arial, sans-serif' }}>Client Code </h6>} />
                    {CustomerDeleteButton}
                </Datagrid>
            </List>
        </>
    )
};

export default CustomerList;
